import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from '../../../common/component/modal/FJCommonModal';
import FJRelinkModal from '../view/FJRelinkModal';
import {FJModalAction} from "../../../redux/action/FJRoot.action";
import FJMediaAction from "../../../redux/action/FJMedia.action";
import FJLocalStore from "../../../store/FJLocalStore";

class FJRelinkModalContainer extends Component {

  render() {
    let {
      visible,
      onCancel,
      linkMedias,
      linkMediaList,
      isShowRelinkBtn,
      cutRelinkBtn
    } = this.props;

    return (
      <FJCommonModal visible={visible}
                     hasInnerCloseBtn
                     hasInnerTitle
                     title={FJLocalStore._('relink-missing-files')}
                     onCancel={onCancel}
                     width='540px'
      >
        <FJRelinkModal visible={visible}
                       onCancel={onCancel}
                       onSubmit={onCancel}
                       linkMedias={linkMedias}
                       linkMediaList={linkMediaList}
                       cutRelinkBtn={cutRelinkBtn}
                       isShowRelinkBtn={isShowRelinkBtn}
        />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowRelinkModal,
    linkMediaList: state.media.linkMediaList,
    isShowRelinkBtn: state.media.isShowRelinkBtn
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onCancel: function () {
      dispatch(FJModalAction.setIsShowRelinkModalAction(false));
      dispatch(FJMediaAction.checkHaveLinkMediaAction());
    },
    linkMedias: function (files, linkId, callback) {
      dispatch(FJMediaAction.linkMediasAction(files, linkId, callback));
    },
    cutRelinkBtn: function () {
      dispatch(FJMediaAction.cutRelinkBtn());
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJRelinkModalContainer);
